import { useRouteError } from "react-router-dom";

export default function ErrorPage() {
  const error = useRouteError();
  throw error instanceof Error ? error : new Error("Unknown error");
  return null;
}
